import styled from "styled-components";

export const DateTimeBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  .fui-AccordionPanel {
    padding: 0px 8px 16px 8px;
    .fui-Dropdown {
      width: 100%;
    }
  }
`;
